import React from "react";
import homeImg from "../assets/aboutimg.svg";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
export default function About() {
  return (
    <div className="bg-about-bg min-h-screen h-auto w-full flex flex-col justify-between">
      <div>
        <Navbar
          bgrenk="bg-about-bg"
          renk="text-about-pr"
          renk2="text-about-sc"
        ></Navbar>
        <div className="lg:flex justify-between mx-[16px] md:mx-[150px] items-center ">
          <div>
            <h1 className="text-4xl md:text-6xl flex leading-[75px] font-semibold text-about-pr">
              Hakkımda.
            </h1>
            <p className="text-xl md:text-2xl font-[400] max-w-[600px] mt-[16px] text-about-sc">
              Sorun çözme konusunda yetenekli ve kullanıcı dostu arayüzler
              yaratmayı seven tutkulu bir Ön Uç Geliştiricisiyim. Yaklaşık iki
              yıllık deneyimimle, dinamik ekipler içinde etkili bir şekilde iş
              birliği yaparken temiz, verimli ve etkili çözümler sunmaya
              odaklanıyorum. Her zaman öğrenmeye hevesliyim, zorlukları büyüme
              fırsatlarına dönüştürmeyi seviyorum. Dans etmeyi, şarkı söylemeyi,
              uçsuz bucaksız denizlerde yüzmeyi ve scubadiving yapmayı çok
              severim. Çok güzel hayallerim var ve hayatımı bu hayalleri önce
              hedefe sonra da gerçekliğe dönüştürmek için yaşıyorum.
            </p>
          </div>
          <div className="flex justify-center lg:justify-end mt-10">
            <img className="w-[200px] md:w-[437px]" src={homeImg} alt="" />
          </div>{" "}
        </div>
      </div>
      <Footer renk2="text-about-sc"></Footer>
    </div>
  );
}
